var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "ListingViews",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-listing-views","viewBox":"0 0 100 100"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M59.102 40.468c-2.845-1.12-5.768-1.744-8.485-1.744-3.224 0-6.546.646-9.708 1.875a10.525 10.525 0 0 0-.97 4.434c0 5.719 4.522 10.354 10.098 10.354 5.576 0 10.096-4.635 10.096-10.354 0-1.608-.356-3.16-1.03-4.565zm4.473 2.213c.126.771.19 1.557.19 2.352 0 7.776-6.146 14.079-13.728 14.079s-13.73-6.303-13.73-14.079c0-.763.06-1.519.177-2.26-3.531 2.128-6.656 5.051-8.933 8.665.231.215.481.44.75.676a40.958 40.958 0 0 0 5.022 3.747c5.345 3.39 11.177 5.415 17.294 5.415 6.102 0 11.698-2.015 16.67-5.385a35.073 35.073 0 0 0 4.605-3.72c.255-.245.491-.48.707-.701-2.072-3.52-5.329-6.56-9.024-8.789zM50 100C22.386 100 0 77.614 0 50S22.386 0 50 0s50 22.386 50 50-22.386 50-50 50zm0-4c25.405 0 46-20.595 46-46S75.405 4 50 4 4 24.595 4 50s20.595 46 46 46zm26.447-45.1L77 52.004l-.781.949c-.337.409-.956 1.084-1.843 1.936a38.701 38.701 0 0 1-5.087 4.109C63.763 62.744 57.497 65 50.617 65c-6.863 0-13.327-2.245-19.205-5.972a44.576 44.576 0 0 1-5.469-4.081c-.966-.845-1.645-1.513-2.017-1.914l-.926-1 .664-1.2C29.245 40.741 40.315 35 50.617 35c9.625 0 21.155 6.573 25.83 15.9z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/listing-views.svg